/**
 * Transfer Configuration Registry
 * Central registry for all inventory type transfer configurations
 */

import { transferBottleConfig }   from './transferBottleConfig';
import { transferCapConfig }      from './transferCapConfig';
import { transferLabelConfig }    from './transferLabelConfig';
import { transferSupplyConfig }   from './transferSupplyConfig';
import { transferChemicalConfig } from './transferChemicalConfig';
import { transferProductConfig } from './transferProductConfig';

const transferConfigs = {
  bottles:   transferBottleConfig,
  caps:      transferCapConfig,
  labels:    transferLabelConfig,
  supplies:  transferSupplyConfig,
  chemicals: transferChemicalConfig,
  products:  transferProductConfig
};

/**
 * Get transfer configuration for a specific inventory type
 */
export const getTransferConfig = (inventoryType) => {
  const config = transferConfigs[inventoryType];
  if (!config) {
    throw new Error(`No transfer configuration found for inventory type: ${inventoryType}`);
  }
  return config;
};

/**
 * Check if transfer is supported for this inventory type
 */
export const hasTransferConfig = (inventoryType) => {
  return !!transferConfigs[inventoryType];
};
